import { render, staticRenderFns } from "./CampaignPickls.vue?vue&type=template&id=33f7517e&scoped=true&"
import script from "./CampaignPickls.vue?vue&type=script&lang=ts&"
export * from "./CampaignPickls.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignPickls.vue?vue&type=style&index=0&id=33f7517e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f7517e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f7517e')) {
      api.createRecord('33f7517e', component.options)
    } else {
      api.reload('33f7517e', component.options)
    }
    module.hot.accept("./CampaignPickls.vue?vue&type=template&id=33f7517e&scoped=true&", function () {
      api.rerender('33f7517e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/CampaignPickls.vue"
export default component.exports